import React, { PropTypes } from 'react'
import Parallax from '../Parallax'
// import PerformanceItem from './PerformanceItem'
import BottomNavigation from './../BottomNavigation'
import {ROUTE_HIRING} from '../../constants'
import PerformanceSocial from "./PerformanceSocial";

const Performances = ({ performances }) => {

    return (
      <div>

        <Parallax image="performances" alt="Prestations" title="Prestations" />

        {/*<ul className="collection">*/}
        {/*  {performances.map(performance => <li key={performance.startDate} className="collection-item avatar"><PerformanceItem performance={performance}/></li>)}*/}
        {/*</ul>*/}

        <div className="row content section">
            <div className="col s12 m12 s12">
                <PerformanceSocial/>
            </div>
        </div>

        <Parallax image="contact" alt="Contact"/>

        <BottomNavigation previousText="Recrutement" previousLink={ROUTE_HIRING}/>

    </div>

)


}

const { array } = PropTypes
Performances.propTypes = {
  performances: array
}

export default Performances



/** WEBPACK FOOTER **
 ** ./src/components/Performances/Performances.jsx
 **/